import {
  ResponseProjectionIssueSeverityEnum,
  type ResponseProjectionIssue,
} from '@reach/shared-types/tool-response-projection';
import styles from './ResponseMapping.module.css';

const ISSUE_LABEL = {
  [ResponseProjectionIssueSeverityEnum.ERROR]: 'Fix',
  [ResponseProjectionIssueSeverityEnum.WARNING]: 'Check',
} as const satisfies Record<ResponseProjectionIssueSeverityEnum, string>;

export const PreviewIssueRow = ({ issue }: { issue: ResponseProjectionIssue }) => {
  const isError = issue.severity === ResponseProjectionIssueSeverityEnum.ERROR;
  const issueClass = isError ? styles.issueError : styles.issueWarning;
  return (
    <li className={issueClass}>
      <span>{ISSUE_LABEL[issue.severity]}</span>
      <span>{issue.message}</span>
    </li>
  );
};
